import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Button, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, Typography, IconButton, Checkbox, ListItemText, CircularProgress, Paper, Divider, Box, makeStyles } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import * as actions from '../actions';
import { numberAndDecimalRegex } from '../../../../constant';
import { addModelValidation } from '../../../Validation/AddModel';
import Input from '../../../../components/common/Input';
import { AutoComplete } from 'rsuite';

const useStyles = makeStyles((theme) => ({
  sectionHeader: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  cardContainer: {
    padding: theme.spacing(3),
    height: '100%',
    boxShadow: 'none',
    borderRadius: '4px',
  },
  formControl: {
    marginBottom: theme.spacing(1),
  },
  groupContainer: {
    padding: theme.spacing(2),
    borderRadius: '4px',
    marginBottom: theme.spacing(1),
    backgroundColor: '#fbfbfb',
  }
}));

export const months = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

export default function AddHeatpumpModels() {
  const { modelId } = useParams()
  const dispatch = useDispatch()
  const history = useHistory();

  const { isUpdating = false, isCreating = false, isFetchingSingleModel = false } = useSelector(state => state.heatPumpDevicesModels)

  const [modelData, setModelData] = useState({
    model_name: '',
    min_temp: '',
    max_temp: '',
    boost_mode_exists: "",
    series_type: "select",
  })
  const [errors, setErrors] = useState({})
  const [monthGroups, setMonthGroups] = useState([{ selectedMonths: [], temp: "" }])

  const modelChangeHandler = (e) => {
    let { value, name } = e.target;
    if (name === 'model_name' && value.length > 60) return;
    if ((name === 'min_temp' || name === 'max_temp') && value && !value?.match(numberAndDecimalRegex)) return;
    if ((name === 'min_temp' || name === 'max_temp')) {
      value = +value
    }
    setModelData({ ...modelData, [name]: value })
  }

  const handleGroupChange = (index, field, value) => {
    const updatedGroups = [...monthGroups];
    if (field === 'temp' && value && !value.toString().match(numberAndDecimalRegex)) return;
    updatedGroups[index][field] = value;
    setMonthGroups(updatedGroups);
  }

  const addGroup = () => {
    setMonthGroups([...monthGroups, { selectedMonths: [], temp: "" }]);
  }

  const removeGroup = (index) => {
    if (monthGroups.length === 1) return;

    const updatedGroups = monthGroups.filter((_, i) => i !== index);
    setMonthGroups(updatedGroups);
  }

  const getModelDetails = () => {
    dispatch(actions.getSingleHeatPumpModel(modelId)).then((res) => {
      if (res?.code === 200) {
        const { boost_mode_exists, max_temp, min_temp, model_name, series_type, low_temperature } = res?.info
        setModelData({ ...modelData, boost_mode_exists: boost_mode_exists ? true : false, max_temp, min_temp, model_name, series_type })

        const tempMonthGroups = [];
        const tempGroups = Object.groupBy(low_temperature, ({ temp }) => temp);

        Object.entries(tempGroups)?.forEach(([temp, months]) => {
          tempMonthGroups.push({
            selectedMonths: months?.map(m => m.month),
            temp: temp
          });
        });

        if (tempMonthGroups.length === 0) {
          setMonthGroups([{ selectedMonths: [], temp: "" }]);
        } else {
          setMonthGroups(tempMonthGroups);
        }
      }
    })
  }

  const onSubmit = () => {
    if (isUpdating || isCreating || isFetchingSingleModel) return;

    const { errors, isValid } = addModelValidation({ ...modelData, monthGroups })
    if (!isValid) {
      setErrors(errors)
      return;
    }
    setErrors({});

    const low_temperature = monthGroups?.map(g => g.selectedMonths?.map(m => ({ month: m, temp: Number(g.temp) })))

    const request = {
      ...modelData,
      boost_mode_exists: modelData.boost_mode_exists ? 1 : 0,
      low_temperature: low_temperature?.flat()
    }

    if (modelId) {
      dispatch(actions.updateHeatPumpModel({ ...request, id: modelId })).then(() => {
        history.goBack()
      })
      return;
    }
    dispatch(actions.createHeatPumpModel({ ...request })).then(() => {
      history.goBack()
    })

  }

  useEffect(() => {
    if (modelId) {
      getModelDetails()
    }
  }, [modelId])

  console.log("ERRORS", errors)

  const classes = useStyles();

  return (
    <Grid container className="location-container p-0">
      <Grid item xs={12}>
        <Grid container className="location-head mb-4 con-space-between align-items-center">
          <div className='d-flex align-items-center'>
            <div className="back-btn">
              <div className="back-icon back-btn" onClick={() => history.goBack()}>
                <ArrowBackIosIcon fontSize="small" />
              </div>
            </div>
            <Typography variant="h5" component="h2" style={{ marginLeft: 10, fontWeight: 600 }}>
              {modelId ? "Edit Model" : "Add Model"}
            </Typography>
          </div>
        </Grid>
      </Grid>

      {isFetchingSingleModel ? (
        <Grid item xs={12} className="d-flex justify-content-center p-5">
          <CircularProgress color="primary" />
        </Grid>
      ) : (
        <Grid container spacing={3} className="px-5">
          {/* General Information Section */}
          <Grid item xs={12} md={6}>
            <Paper className={classes.cardContainer} elevation={0}>
              <Typography className={classes.sectionHeader}>General Information</Typography>


              <Grid container spacing={2} className='mt-2'>
                <Grid item xs={12}>
                  <FormControl fullWidth className={classes.formControl}>
                    <Input
                      variant="outlined"
                      fullWidth
                      name="model_name"
                      label="Model Name *"
                      type="text"
                      value={modelData?.model_name || ""}
                      onChange={modelChangeHandler}
                      error={errors?.model_name}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl variant="outlined" fullWidth className={classes.formControl}>
                    <InputLabel>Series Type</InputLabel>
                    <Select
                      label="Series Type"
                      value={modelData.series_type}
                      onChange={(e) => setModelData({ ...modelData, series_type: e.target.value })}
                    >
                      <MenuItem value={"select"}>Select</MenuItem>
                      <MenuItem value={"pro"}>Pro</MenuItem>
                      {/* <MenuItem value={"ultra"}>Ultra</MenuItem> */}
                    </Select>
                    {errors?.series_type && <FormHelperText error>{errors?.series_type}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl variant="outlined" fullWidth className={classes.formControl}>
                    <InputLabel>Boost Mode</InputLabel>
                    <Select
                      label="Boost Mode"
                      value={modelData.boost_mode_exists}
                      onChange={(e) => setModelData({ ...modelData, boost_mode_exists: e.target.value })}
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                    {errors?.boost_mode_exists && <FormHelperText error>{errors?.boost_mode_exists}</FormHelperText>}
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Temperature Limits Section */}
          <Grid item xs={12} md={6}>
            <Paper className={classes.cardContainer} elevation={0}>
              <Typography className={classes.sectionHeader}>Temperature Limits</Typography>

              <Grid container spacing={2} className='mt-2'>
                <Grid item xs={6}>
                  <FormControl fullWidth className={classes.formControl}>
                    <Input
                      variant="outlined"
                      fullWidth
                      name="min_temp"
                      label={`Min Temp (${"\u2103"})`}
                      type="text"
                      value={modelData?.min_temp || ""}
                      onChange={modelChangeHandler}
                      error={errors?.min_temp}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth className={classes.formControl}>
                    <Input
                      variant="outlined"
                      fullWidth
                      name="max_temp"
                      label={`Max Temp (${"\u2103"})`}
                      type="text"
                      value={modelData?.max_temp || ""}
                      onChange={modelChangeHandler}
                      error={errors?.max_temp}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Low Temperature Configuration Section */}
          <Grid item xs={12}>
            <Paper className={classes.cardContainer} elevation={0}>
              <Typography className={classes.sectionHeader}>Low Temperature (Month Wise)</Typography>

              {monthGroups.map((group, index) => (
                <div key={index} className={classes.groupContainer} style={{ marginTop: "10px" }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={5}>
                      <FormControl variant="outlined" fullWidth error={months.some(m => group.selectedMonths.includes(m) && errors[`${m}_low_temp`])}>
                        <InputLabel>Select Months</InputLabel>
                        <Select
                          multiple
                          MenuProps={{
                            MenuListProps: {
                              disablePadding: true,
                            },
                          }}
                          label="Select Months"
                          value={group.selectedMonths}
                          onChange={(e) => handleGroupChange(index, 'selectedMonths', e.target.value)}
                          renderValue={(selected) => selected.map(s => s.toUpperCase()).join(', ')}
                        >
                          {months.map((month) => (
                            <MenuItem
                              key={month}
                              value={month}
                              disabled={monthGroups.some((g, i) => i !== index && g.selectedMonths.includes(month))}
                            >
                              {group.selectedMonths.indexOf(month) > -1 ? (
                                <>
                                  <svg className="tag-selected-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="rgba(0,168,142,1)" width={24} height={24}>
                                    <path d="M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"></path>
                                  </svg>
                                  <ListItemText primary={month.toUpperCase()} />
                                </>
                              ) : (
                                <ListItemText primary={month.toUpperCase()} className='ml-4' />
                              )}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={9} sm={5}>
                      <Input
                        variant="outlined"
                        fullWidth
                        label="Temperature"
                        type="text"
                        value={group.temp}
                        onChange={(e) => handleGroupChange(index, 'temp', e.target.value)}
                        error={group.selectedMonths.some(m => errors[`${m}_low_temp`])}
                      />
                    </Grid>
                    <Grid item xs={3} sm={2} className="d-flex" style={{ justifyContent: "flex-end" }}>
                      {monthGroups.flatMap(g => g.selectedMonths).length < months.length && (
                        <IconButton onClick={addGroup} color="primary">
                          <AddCircleIcon />
                        </IconButton>
                      )}
                      {monthGroups.length > 1 && (
                        <IconButton onClick={() => removeGroup(index)} color="secondary">
                          <RemoveCircleIcon />
                        </IconButton>
                      )}
                    </Grid>
                  </Grid>
                </div>
              ))}

              {errors?.low_temperature && (
                <FormHelperText error style={{ marginTop: 8 }}>{errors?.low_temperature}</FormHelperText>
              )}
            </Paper>
          </Grid>

          {/* Action Buttons */}
          <Grid item xs={12} className="d-flex justify-content-end mb-4">
            <Button
              variant="contained"
              color="primary"
              className="btn-custom-primary button-btn"
              disabled={isUpdating || isCreating || isFetchingSingleModel}
              onClick={onSubmit}
              style={{ minWidth: 120 }}
            >
              {isUpdating || isCreating || isFetchingSingleModel ? (
                <CircularProgress color="inherit" size={24} />
              ) : (
                modelId ? "Update" : "Add"
              )}
            </Button>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

